import { FC } from 'react';

type Props = {
  id: number;
  text: string;
};

export const TranscriptSystemMessage: FC<Props> = ({ id, text }) => (
  <div data-message-id={id} className="flex items-center justify-center w-full py-2">
    <div className="text-sm text-(--color-chat-event) bg-muted/50 px-4 py-2 rounded-full">{text}</div>
  </div>
);
